import React, { useContext, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import { AuthContext } from "../../contexts/AuthProvider";

const Login = () => {
  const { signin, signInWithGoogle, resetPassword } =
    useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [emailForReset, setEmailForReset] = useState("");

  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";

  // 🔐 LOGIN WITH EMAIL
  const handleSubmit = async (e) => {
    e.preventDefault();
    const email = e.target.email.value;
    const password = e.target.password.value;

    try {
      setLoading(true);

      const result = await signin(email, password);

      // 👉 get JWT from backend
      const res = await fetch(
        `https://server-gs.vercel.app/user/${result.user.email}`,
        {
          method: "PUT",
          headers: {
            "content-type": "application/json",
          },
          body: JSON.stringify({ email: result.user.email }),
        }
      );

      const data = await res.json();

      if (!data?.token) {
        throw new Error("Token not generated");
      }

      // 👉 save token
      localStorage.setItem("aircnc-token", data.token);

      toast.success("Login successful!");
      navigate(from, { replace: true });
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  // 🔐 GOOGLE LOGIN
  const handleGoogleLogin = async () => {
    try {
      setLoading(true);

      const result = await signInWithGoogle();

      const res = await fetch(
        `https://server-gs.vercel.app/user/${result.user.email}`,
        {
          method: "PUT",
          headers: {
            "content-type": "application/json",
          },
          body: JSON.stringify({ email: result.user.email }),
        }
      );

      const data = await res.json();
      localStorage.setItem("aircnc-token", data.token);

      toast.success("Login successful!");
      navigate(from, { replace: true });
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  // 🔁 RESET PASSWORD
  const handleReset = async () => {
    if (!emailForReset) {
      toast.error("Enter your email first");
      return;
    }

    try {
      await resetPassword(emailForReset);
      toast.success("Password reset email sent");
    } catch (err) {
      toast.error(err.message);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="w-full max-w-md bg-white p-8 rounded-xl shadow-lg">
        <h2 className="text-3xl font-bold text-center mb-6">
          Login
        </h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="email"
            name="email"
            required
            onBlur={(e) => setEmailForReset(e.target.value)}
            placeholder="Email"
            className="w-full px-4 py-3 border rounded-lg"
          />

          <input
            type="password"
            name="password"
            required
            placeholder="Password"
            className="w-full px-4 py-3 border rounded-lg"
          />

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-black text-white py-3 rounded-lg"
          >
            {loading ? "Loading..." : "Login"}
          </button>
        </form>
{/* 
        <button
          onClick={handleGoogleLogin}
          className="w-full mt-4 border py-3 rounded-lg"
        >
          Continue with Google
        </button> */}

        <button
          onClick={handleReset}
          className="block text-sm text-center mt-4 text-gray-600 underline"
        >
          Forgot password?
        </button>
      </div>
    </div>
  );
};

export default Login;
